/**
 * 接口支持以下：
 * [ "doc", "docx", "xls", "xlsx", "pdf", "txt", "zip", "rar", "p12", "pfx", "cer", "apk", "cad", "html", "ppt", "pptx", "dwg", "mp4", "ogg", "webm", "json", "mp3", "csv", "wav", "bin"
"jpg", "jpeg", "png", "gif", "heic"]
 * 将原来配置中去掉：ai,7z,dwt,eps,wmf,cdr,plt,dxf,svg,tif,fxg,bmp
 * 但是7z应该等于zip，另增加了以下
 * 7z,json,mp3,mp4,wav
 */
export const SUPPORTED_FILE_TYPES =
  'txt,ppt,pptx,rar,zip,pdf,dwg,xls,xlsx,csv,doc,docx,jpg,jpeg,png,gif,json,mp3,mp4,wav';

/**评论/回复文字数最大长度*/
export const INPUT_WORD_LIMIT = 200;
/**评论/回复富文本内容最大长度*/
export const SUBMIT_CONTENT_LIMIT = 6000;

/**附件大小限制 10M (10*1024*1024) 作为获取配置失败时的默认值*/
export const ATTACHMENT_MAX_SIZE = 10485760;
export const ATTACHMENT_MAX_SIZE_KEY = 'WRF_CommentAttachmentMaxSize';
export const ATTACHMENT_MAX_COUNT = 10;

/**用户信息存储：最新提到的人*/
export const RECENTLY_MENTIONED_USERS_KEY = 'wrp_recently_mentioned_users';
export const RECENTLY_MENTIONED_USERS_LIMIT = 20;

export const MENTIONED_USER_CLASS_NAME = 'teld-comment--mentioned-user';

export const TOP_LEVEL_ORG_ID = '0';
export const TELD_ORG_ID = 'fb247fb4-13d1-4c1b-acf8-27278b9bd0b1';

/**
 * SG接口 GetUserList 参数 FieldName 的可选枚举值定义
 *
 * 原始说明：
 * 	 选择全部传空字符串（Account、RealName、Mobile、Email全相等匹配），选择帐号传Account（右模糊匹配），选择姓名传RealName（右模糊匹配），选择手机号传Mobile（右模糊匹配），选择邮箱传Email（右模糊匹配）。
 * 文档地址：https://k.teld.cn/pages/viewpage.action?pageId=419139738
 */
export const SG_USER_LIST_QUERY_FIELDS = {
  ALL_AND_STRICT: '',
  ACCOUNT: 'Account',
  REAL_NAME: 'RealName',
  MOBILE: 'Mobile',
  EMAIL: 'Email',
};
